import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M27.567 11.831 5.56 5.081A2 2 0 0 0 3 7v18a2 2 0 0 0 2.565 1.918L16 23.715v1.284a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V21.26l3.567-1.094A2.01 2.01 0 0 0 29 18.25v-4.5a2.01 2.01 0 0 0-1.433-1.918M16 21.624 5 24.999v-18l11 3.375zm6 3.375h-4V23.1l4-1.227zm5-6.75h-.014L18 21.009v-10.02l8.986 2.75H27v4.51"
    />
  </svg>
);
const SvgIconMegaphone = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconMegaphone);
export default Memo;
